import { z } from 'zod';

import type { ClientToolDefinition } from './types';

const schema = z
  .object({
    question: z.string(),
    options: z.array(z.string()).optional(),
  })
  .passthrough();

/**
 * Dispatched through the FE registry like a client tool even though the
 * server's `toolKind` treats it as its own kind — the loop receives it as an
 * ordinary `tool_call` event.
 */
export const askUserTool: ClientToolDefinition<typeof schema> = {
  schema,
  // Its user-facing output IS the clarifying question. Any streamed preamble
  // ("Generating a chart…") describes work the model is NOT doing because it
  // needs to ask instead, and would sit misleadingly next to the question.
  narrationPolicy: 'drop',
  run({ question, options }, { deps }) {
    deps.askUser({ question, options });
    return { resultForModel: 'asked user; awaiting reply', endsTurn: true };
  },
};
